<template>
 <v-container class="d-flex justify-center align-center" style="height: 100vh;">
    <v-card width="600px" class="pa-5 d-flex flex-column align-center">
        <h1 class="text-center indigo--text font-weight-bold">Verify Your Email</h1>
        <v-card-subtitle>Please enter the code we sent to your email address</v-card-subtitle>
        <v-card-text>
            <v-form ref="loginForm" v-model="validLoginForm">
                <v-text-field
                  v-model="code"
                  label="code"
                  dense
                  outlined
                  clearable
                  color="indigo"
                  :rules="[rules.required]"
                />
            </v-form>
             <v-btn color="indigo" block class="rounded-xl white--text" @click="verify">submit</v-btn>
        </v-card-text>
    </v-card>
 </v-container>
</template>
<script>
import { headersNoAuth } from '../links'
export default {
  data () {
    return {
      loginForm: null,
      validLoginForm: true,
      code: null,
      loading: false,
      text: null,
      color: null,
      rules: {
        required: value => !!value || 'this field is required'
      }
    }
  },
  methods: {
    verify () {
      this.$refs.loginForm.validate()
      if (this.validLoginForm) {
        this.loading = true
        const body = {
          code: this.code,
          email: this.$store.state.registeredMail
        }
        const header = { headers: headersNoAuth() }

        this.$http.post('https://www.atnbookingengine.com/api/email/verify', body, header)
          .then(response => {
            if (response.data.status) {
              this.$store.commit('showFeedback', { text: response.body.message, color: 'success' })
              this.$store.commit('setUserId', response.data.data.user.id)
              this.$store.commit('setUser', response.data.data.token.access_token)
              localStorage.setItem('BVtoken', response.data.data.token.access_token)
              this.$store.commit('setUserData', response.data.data.user)
              this.$router.push('/')
              // localStorage.setItem('token', response.data.data.token.access_token)
            } else {
              this.$store.commit('showFeedback', { text: response.data.message, color: 'error' })
            }
          }).finally(() => {
            this.loading = false
          })
      }
    }

  }
}
</script>
